<template>
  <div class="role">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2">
        <LinkButton buttonText="Tambah Role" url="/role/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:flex-col mdmax:gap-2">
        <!-- <div class="w-2/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Role</label>
          <CustomSelect :options="roleList" v-model="selectedRole" :defaultValue="selectedRole" placeholder="Pilih role" optionLabel="name" />
        </div> -->
        <div class="w-3/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Pencarian nama, ID, email role" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/user/role/detail/${entry.id}`" linkType="internal" type="secondary" size="small" />
        <span v-else>{{ entry[column.field] || '-' }}</span>
      </template>
    </TableComponent>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search')
  },
  data: () => ({
    selectedRole: '',
    searchTerm: '',
    page: 1,
    totalPages: 10,
    total: 100,
    perPage: 10,
    currentPage: 1,
    hasMorePages: true,
    columns: [
      // { label: 'ID', field: 'id' },
      { label: 'Nama Role', field: 'name' },
      { label: 'Deskripsi', field: 'description' },
      { label: 'Total User', field: 'phone' },
      { label: 'Capability', field: 'role' },
      { label: 'Action', field: 'action' }
    ]
  }),
  computed: {
    ...mapGetters('role', ['roleList']),
    ...mapGetters('common', ['isMobile']),
    filteredData() {
      let temp = this.roleList || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  methods: {
    ...mapActions('role', ['getRoleList']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getRole(searchTerm = '') {
      this.getRoleList({
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          search_keyword: searchTerm
        }
      })
        .then(res => {
          this.total = res.data.meta.total_item
          this.totalPages = res.data.meta.total_page
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    doSearch() {
      this.getRole(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/user/role', query: { page: page } })
      this.page = page
      this.currentPage = page
    },
    goToDetail(target) {
      this.$router.push(`/user/role/detail/${target}`)
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/user/role', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getRole()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getRole()
      } else {
        this.$router.push({ path: '/user/role', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
